export type CodeGateResult = {
  ok: boolean;
  acceptedCode: bigint | null;
  reason: string;
  consecutiveCount: number;
  bestWindowCode: bigint | null;
  bestWindowVotes: number;
  windowSize: number;
};

export class StableCodeGate {
  private history: bigint[] = [];
  private lastCode: bigint | null = null;
  private consecutiveCount = 0;

  constructor(
    private readonly requiredConsecutive = 3,
    private readonly windowSize = 7,
    private readonly minWindowVotes = 4
  ) {}

  clear():void
  {
    this.lastCode = null;
    this.history = [];
    this.consecutiveCount = 0;
  }
  push(code: bigint): CodeGateResult {
    if (this.lastCode === code) {
      this.consecutiveCount++;
    } else {
      this.lastCode = code;
      this.consecutiveCount = 1;
    }

    this.history.push(code);
    if (this.history.length > this.windowSize) {
      this.history.shift();
    }

    const counts = new Map<bigint, number>();
    for (const c of this.history) {
      counts.set(c, (counts.get(c) ?? 0) + 1);
    }

    let bestWindowCode: bigint | null = null;
    let bestWindowVotes = 0;

    for (const [c, count] of counts.entries()) {
      if (count > bestWindowVotes) {
        bestWindowCode = c;
        bestWindowVotes = count;
      }
    }

    if (this.consecutiveCount >= this.requiredConsecutive) {
      return {
        ok: true,
        acceptedCode: code,
        reason: `consecutive x${this.consecutiveCount}`,
        consecutiveCount: this.consecutiveCount,
        bestWindowCode,
        bestWindowVotes,
        windowSize: this.windowSize,
      };
    }

    if (bestWindowCode !== null && bestWindowVotes >= this.minWindowVotes) {
      return {
        ok: true,
        acceptedCode: bestWindowCode,
        reason: `window vote ${bestWindowVotes}/${this.history.length}`,
        consecutiveCount: this.consecutiveCount,
        bestWindowCode,
        bestWindowVotes,
        windowSize: this.windowSize,
      };
    }

    return {
      ok: false,
      acceptedCode: null,
      reason: "not stable yet",
      consecutiveCount: this.consecutiveCount,
      bestWindowCode,
      bestWindowVotes,
      windowSize: this.windowSize,
    };
  }

  reset(): void {
    this.history = [];
    this.lastCode = null;
    this.consecutiveCount = 0;
  }

  getHistory(): bigint[] {
    return [...this.history];
  }
}